import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import sxPropType from 'propTypes/sx';

import { gmConfig } from 'helpers/config';
import Pagination from 'components/Pagination/Pagination';

const buildHref = (path, page) => {
  let pathWithPage = path;
  if (page > 1) {
    pathWithPage += `?page=${page}`;
  }
  return `https://${gmConfig.domains.www}${pathWithPage}`;
};

const NextPagination = (props) => {
  const { itemsPerPage, page, path, total, className, sx } = props;
  const numberOfPages = Math.ceil(total / itemsPerPage);
  const showPrev = page !== 1;
  const showNext = page !== numberOfPages;
  const hidePagination = page === 1 && !showNext;

  if (hidePagination) return null;

  return (
    <>
      <Head>
        {showPrev && <link data-testid="prev" rel="prev" href={buildHref(path, page - 1)} />}
        {showNext && <link data-testid="next" rel="next" href={buildHref(path, page + 1)} />}
      </Head>
      {numberOfPages > 1 && (
        <Pagination
          className={className}
          numberOfPages={numberOfPages}
          currentPageIndex={page}
          path={path}
          sx={sx}
        />
      )}
    </>
  );
};

NextPagination.propTypes = {
  className: PropTypes.string,
  itemsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  sx: sxPropType,
};
NextPagination.defaultProps = {
  className: null,
  sx: {},
};

export default NextPagination;
